<template>
  <div class="car">
    <Header />
    <Nav />
    <div class="pages">
      <div class="car-menu">
        宏云课堂
        <img src="../assets/icon/right-gray.svg" alt="">
        我的购物车
      </div>
      <div class="car-title">
        <h4>我的购物车</h4>
        <span>共记<i>2</i>门课程</span>
      </div>
      <div class="car-td">
        <span>
          <el-checkbox></el-checkbox> 全选
        </span>
        <span>课程名称</span>
        <span>单价</span>
      </div>
      <div class="car-container">
        <div class="car-list">
          <div class="car-list-date">2021-05-27</div>
          <ul>
            <li>
              <el-checkbox></el-checkbox>
              <img src="../assets/company/list.png" alt="">
              <h5>课程名称永兴科技发展有限公司</h5>
              <b>*1</b>
              <i>¥399</i>
            </li>
            <li>
              <el-checkbox></el-checkbox>
              <img src="../assets/company/list.png" alt="">
              <h5>课程名称永兴科技发展有限公司</h5>
              <b>*1</b>
              <i>¥399</i>
            </li>
          </ul>
          <div class="sum">选中共计<i>1</i>笔订单</div>
        </div>
        <div class="car-sum">
          合计<span>￥399</span>
        </div>
        <div class="car-btn">去结算</div>
      </div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from "../components/Fixed.vue";
export default {
  name: "Car",
  components: {
    Header,
    Nav,
    Footer,
    Fixed
  },
};
</script>

<style lang="less" scoped>
.car {
  &-menu {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
    img {
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  &-title {
    width: 1300px;
    margin: 0 auto;
    height: 60px;
    background: #ffffff;
    display: flex;
    align-items: center;
    h4 {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 60px;
      margin-left: 40px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 60px;
      margin-left: 12px;
      i {
        color: #ff7e20;
        font-style: normal;
      }
    }
  }
  &-td {
    width: 1300px;
    height: 52px;
    background: #eeeeee;
    margin: 7px auto 0;
    span {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 52px;
      &:nth-child(1) {
        margin-left: 77px;
      }
      &:nth-child(2) {
        margin-left: 207px;
      }
      &:nth-child(3) {
        margin-left: 368px;
      }
    }
  }
  &-container {
    background: #fff;
    width: 1300px;
    margin: 0 auto;
    padding-top: 32px;
    padding-bottom: 167px;
  }
  &-list {
    width: 1200px;
    height: 296px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    margin: 0 auto;
    &-date {
      height: 42px;
      background: #f8f8f8;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #202429;
      line-height: 42px;
      padding-left: 67px;
    }
    ul {
      li {
        margin-top: 35px;
        display: flex;
        align-items: center;
        /deep/.el-checkbox {
          margin-left: 27px;
        }
        img {
          margin-left: 24px;
          width: 100px;
          height: 56px;
        }
        h5 {
          margin-left: 47px;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #202429;
          line-height: 25px;
        }
        b {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #202429;
          line-height: 25px;
          margin-left: 19px;
        }
        i {
          font-style: normal;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ff7a38;
          line-height: 25px;
          margin-left: 232px;
        }
      }
    }
    .sum {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #666666;
      line-height: 25px;
      text-align: right;
      margin-right: 62px;
      margin-top: 20px;
      i {
        font-style: normal;
        color: #FF7E20;
      }
    }
  }
  &-sum {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #666666;
    line-height: 25px;
    margin-right: 84px;
    text-align: right;
    margin-top: 48px;
    span {
      font-size: 24px;
      color: #FF7A38;
    }
  }
  &-btn {
    width: 184px;
    height: 32px;
    background: linear-gradient(90deg, #FD441F 0%, #E1251B 100%);
    border-radius: 2px;
    border: 1px solid #E1251B;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 32px;
    text-align: center;
    margin: 0 auto;
    margin-top: 98px;
  }
}
</style>